module.exports = __webpack_public_path__ + "img/a86647d.jpg";